import { render, staticRenderFns } from "./EntregaEnviarParaAprovacao.vue?vue&type=template&id=26e3e882"
import script from "./EntregaEnviarParaAprovacao.vue?vue&type=script&lang=js"
export * from "./EntregaEnviarParaAprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports